import { render } from "./SalesMultiCustomerPageShell.vue?vue&type=template&id=c1cb4890"
import script from "./SalesMultiCustomerPageShell.vue?vue&type=script&lang=js"
export * from "./SalesMultiCustomerPageShell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__